import { Pipe, PipeTransform } from '@angular/core';
import { GalleryDto } from '@picflow/types';
import { convertGalleryDownloadSize } from 'src/app/lib/convert-gallery-download-size';

@Pipe({
  name: 'allowAssetDownload',
  standalone: true,
})
export class AllowAssetDownloadPipe implements PipeTransform {
  transform(gallery: GalleryDto): boolean {
    if (!gallery.download_single_asset) return false;
    const allowedSizes = convertGalleryDownloadSize(gallery.download_media_size);
    return allowedSizes.small && allowedSizes.medium && allowedSizes.large;
  }
}
